import React, { useEffect, useState, useRef } from 'react';
import Modal from 'react-modal';
import './App.css';

import menuIcon from './assets/menu.png';
import promocaoIcon from './assets/promocao.png';
import oracaoIcon from './assets/oracao.png';
import facebookIcon from './assets/facebook.png';
import instagramIcon from './assets/instagram.png';
import youtubeIcon from './assets/youtube.png';
import whatsappIcon from './assets/whatsapp.png';
import emailIcon from './assets/email.png';
import telefoneIcon from './assets/telefone.png';
import siteIcon from './assets/site.png';
import logo from './assets/logo.png';
import playIcon from './assets/play.png';
import pauseIcon from './assets/pause.png';
import volumeIcon from './assets/volume.png';
import volumeIconMudo from './assets/volumemudo.png';
import audioGif from './assets/audio.gif';

const streamUrl = 'https://s33.maxcast.com.br:9172/live';
const whatsappUrl = 'https://wa.me/5564993127115';
const instagramUrl = 'https://www.instagram.com/radiogospelhd';
const facebookUrl = 'https://www.facebook.com/gospelhd';
const youtubeUrl = 'https://www.youtube.com/@radiogospelhd';
const email = 'contato@gospeel.com.br';
const phone = '5564993127115';
const site = 'https://gospelhd.com.br';

const Player = () => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [volume, setVolume] = useState(0.5);
    const [isMenuVisible, setIsMenuVisible] = useState(false);
    const [notificationsEnabled, setNotificationsEnabled] = useState(false);
    const [deferredPrompt, setDeferredPrompt] = useState(null);

    // Cria uma referência para o áudio
    const audioRef = useRef(null);

    useEffect(() => {
        // Instancia o áudio uma vez apenas
        const audio = new Audio(streamUrl);
        audio.volume = volume;
        audioRef.current = audio;

        // Configura os eventos
        audio.addEventListener('canplay', () => setIsLoading(false));
        audio.addEventListener('playing', () => setIsLoading(false));
        audio.addEventListener('waiting', () => setIsLoading(true));
        audio.addEventListener('error', (e) => {
            console.error("Erro ao carregar o áudio", e);
            setIsLoading(false);
        });

        // Timeout para exibir o player após 3 segundos, mesmo que o áudio ainda esteja carregando
        const loadTimeout = setTimeout(() => {
            setIsLoading(false);
        }, 3000);

        // Cleanup dos eventos e do timeout ao desmontar o componente
        return () => {
            audio.pause();
            clearTimeout(loadTimeout);
            audio.removeEventListener('canplay', () => setIsLoading(false));
            audio.removeEventListener('playing', () => setIsLoading(false));
            audio.removeEventListener('waiting', () => setIsLoading(true));
            audio.removeEventListener('error', (e) => console.error("Erro ao carregar o áudio", e));
        };
    }, []);

    useEffect(() => {
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
        });
    }, []);

    const handleInstallClick = () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('Usuário aceitou a instalação');
                } else {
                    console.log('Usuário recusou a instalação');
                }
                setDeferredPrompt(null);
            });
        }
    };

    const togglePlayPause = () => {
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause();
            } else {
                setIsLoading(true);
                audioRef.current.play().catch((e) => console.error("Falha ao iniciar o áudio", e));
            }
            setIsPlaying(!isPlaying);
        }
    };

    const onVolumeChange = (value) => {
        setVolume(value);
        if (audioRef.current) {
            audioRef.current.volume = value;
        }
    };

    const openLink = (url) => {
        window.open(url, '_blank');
    };

    return (
        <div className="appBackground">
            <div className="container">
                {/* Menu Sanduíche */}
                <button className="menuButton" onClick={() => setIsMenuVisible(true)}>
                    <img src={menuIcon} alt="Menu" className="menuIcon"/>
                </button>

                {/* Modal do Menu */}
                <Modal
                    isOpen={isMenuVisible}
                    onRequestClose={() => setIsMenuVisible(false)}
                    className="modalContent"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0.75)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        },
                    }}
                >
                    <h2 className="modalTitle">MENU</h2>

                    <button className="menuItem" onClick={() => openLink(whatsappUrl)}>
                        <img src={promocaoIcon} alt="Promoções" className="icon"/>
                        <span>Promoções</span>
                    </button>
                    <button className="menuItem" onClick={() => openLink(whatsappUrl)}>
                        <img src={oracaoIcon} alt="Pedido de Oração" className="icon"/>
                        <span>Pedido de Oração</span>
                    </button>

                    <h3 className="sectionTitle">Notificações</h3>
                    <div className="menuItem">
                        <span>Geral</span>
                        <input
                            type="checkbox"
                            checked={notificationsEnabled}
                            onChange={() => setNotificationsEnabled((prev) => !prev)}
                        />
                    </div>

                    <h3 className="sectionTitle">Redes Sociais</h3>
                    <div className="socialContainer">
                        <button onClick={() => openLink(facebookUrl)} className="socialIcon">
                            <img src={facebookIcon} alt="Facebook"/>
                        </button>
                        <button onClick={() => openLink(instagramUrl)} className="socialIcon">
                            <img src={instagramIcon} alt="Instagram"/>
                        </button>
                        <button onClick={() => openLink(youtubeUrl)} className="socialIcon">
                            <img src={youtubeIcon} alt="YouTube"/>
                        </button>
                        <button onClick={() => openLink(whatsappUrl)} className="socialIcon">
                            <img src={whatsappIcon} alt="WhatsApp"/>
                        </button>
                    </div>

                    <h3 className="sectionTitle">Entre em contato conosco:</h3>
                    <div className="contactContainer">
                        <button onClick={() => openLink(`mailto:${email}`)} className="socialIcon">
                            <img src={emailIcon} alt="Email"/>
                        </button>
                        <button onClick={() => openLink(`tel:${phone}`)} className="socialIcon">
                            <img src={telefoneIcon} alt="Telefone"/>
                        </button>
                        <button onClick={() => openLink(site)} className="socialIcon">
                            <img src={siteIcon} alt="Site"/>
                        </button>
                    </div>
                </Modal>

                {/* Logo centralizada */}
                <div className="logoContainer">
                    <img src={logo} alt="Logo" className="logo"/>
                </div>
                {isPlaying && (
                <img src={audioGif} alt="Áudio tocando" className="audioGif"/>
                )}
                {/* Botão de Instalação do PWA */}
                {deferredPrompt && (
                    <button onClick={handleInstallClick} className="installButton">
                        Instalar Aplicativo
                    </button>
                )}
                {/* Player na parte inferior */}
                <div className="content">
                    <div className="playerContainer">
                        {isLoading ? (
                            <p className="loadingText">Carregando...</p>
                        ) : (
                            <>
                                <div className="controls">
                                    <img src={volumeIconMudo} alt="Volume" className="iconVolume"/>
                                    <input
                                        type="range"
                                        min="0"
                                        max="1"
                                        step="0.01"
                                        value={volume}
                                        onChange={(e) => onVolumeChange(parseFloat(e.target.value))}
                                        className="slider"
                                    />
                                    <img src={volumeIcon} alt="Volume" className="iconVolume"/>
                                </div>
                                <div className="buttons">
                                    <button onClick={togglePlayPause}>
                                        <img src={isPlaying ? pauseIcon : playIcon} alt="Play/Pause" className="icon"/>
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Player;
